import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges Tailwind class names with conflict resolution.
 *
 * Combines `clsx` (for conditional class composition) and `tailwind-merge`
 * (for de-duplicating conflicting utility classes such as `p-2 p-4`),
 * producing a single space-separated class string.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
